export const ProvinceTableHeader = [
  { name: "Code", key: "code", type: "text" },
  { name: "Name", key: "name", type: "text" },
  { name: "Name AR", key: "name_ar", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
];

export const AreaTableHeader = [
  { name: "Name EN", key: "name_en", type: "text" },
  { name: "Name AR", key: "name_ar", type: "text" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
];

export const CityTableHeader = [
  { name: "Name EN", key: "name_en", type: "text" },
  { name: "Name AR", key: "name_ar", type: "text" },
  { name: "Enabled", key: "enabled", type: "switch" },
  { name: "Min SLA", key: "min_sla", type: "text" },
  { name: "Max SLA", key: "max_sla", type: "text" },
  { name: "COD", key: "cod_verification", type: "switch" },
  { name: "Threshold", key: "threshold", type: "text" },
];
